import axios from 'axios'

const user = { 
  getUserLoginAction: () => {
    return axios.get(`${process.env.REACT_APP_API_URL}bmc/LoginAction`).then(res => res.data)
  },
  AcceptAdvisorPush: () => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/AcceptAdvisorPush`
  ).then( res => res.data ),
  RejectAdvisorPush: () => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/RejectAdvisorPush`
  ).then( res => res.data ),
  getUserData: () => axios.get(
    `${process.env.REACT_APP_API_URL}bmc/UserData`
  ).then( res => res.data ),
  getUserInfo: () => axios.get(
    `${process.env.REACT_APP_API_URL}account/UserInfo`
  ).then( res => res.data ),
  getRestorePoint: () => axios.get( 
    `${process.env.REACT_APP_API_URL}bmc/RestorePoint` 
  ).then(res => res.data),
  deletePartner: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/Delete`, data
  ).then( res => res.data ),
  postPerson: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/Person`, data
  ).then( res => res.data ),
  deletePerson: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/delete`, data
  ).then( res => res.data ),
  getUserSettings: () => axios.get(
    `${process.env.REACT_APP_API_URL}bmc/UserSettings`
  ).then( res => res.data),
  updateUserSetting: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/UserSetting`, data
  ).then( res => res.data ),
  updateUserSettings: (data) => axios.post(
    `${process.env.REACT_APP_API_URL}bmc/UserSettings`, data
  ).then( res => res.data ), 
}
export default user